import { render, staticRenderFns } from "./BlogCategoriesSettings.vue?vue&type=template&id=a4ead388&scoped=true"
import script from "./BlogCategoriesSettings.vue?vue&type=script&lang=js"
export * from "./BlogCategoriesSettings.vue?vue&type=script&lang=js"
import style0 from "./BlogCategoriesSettings.vue?vue&type=style&index=0&id=a4ead388&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4ead388",
  null
  
)

export default component.exports